import { render } from "./MarketingPageHero.vue?vue&type=template&id=0b7db630"
import script from "./MarketingPageHero.vue?vue&type=script&lang=js"
export * from "./MarketingPageHero.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__